var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{staticClass:"explorer-searchable-text mr-0",attrs:{"items":_vm.users,"color":"white","item-text":"first_name","label":"Current Responsibles","filter":_vm.customFilter,"clearable":""}})}
var staticRenderFns = []

export { render, staticRenderFns }